import {
  getLeoUuid,
  LeoUUID,
  getObject,
  LeoRPCRequest,
  LeoRPCResponse,
  LeoRPCError,
  LeoRPCResult,
  LeoRPC
} from "@surya-digital/leo-ts-types";
import { BoundedName, BoundedNameDTO } from "../types/boundedName";
import { KeycloakEmail, KeycloakEmailDTO } from "../types/keycloakEmail";
/* eslint-disable import/export */
export abstract class GetOptOutScreenDetailsRPC implements
  LeoRPC<GetOptOutScreenDetailsRPC.Request, GetOptOutScreenDetailsRPC.Response, GetOptOutScreenDetailsRPC.Errors.Errors>
{
  abstract execute(
    request: GetOptOutScreenDetailsRPC.Request
  ): Promise<LeoRPCResult<GetOptOutScreenDetailsRPC.Response, GetOptOutScreenDetailsRPC.Errors.Errors>>;
}

export namespace GetOptOutScreenDetailsRPC {

  export class InvalidRequestError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidRequestError";
    }
  }

  export interface RequestDTO {
    emailId: string;
  }
  
  export class Request implements LeoRPCRequest {
    readonly isGetOptOutScreenDetailsRPCRequest: boolean = true;
  
    readonly emailId: LeoUUID;
  
  
    constructor(
    emailId: LeoUUID
    ) {
      this.emailId = emailId;
    }
  
    static fromDTO(dto: RequestDTO): Request {
      const emailId = getLeoUuid(dto, "emailId", InvalidRequestEmailIdError);
      return new Request(
        emailId
      );
    }
  
    toDTO(): RequestDTO {
      const dto: RequestDTO = {
          emailId: this.emailId.toDTO()
      };
      return dto;
    }
    }
  
  Request.prototype.toString = function toString(): string {
    return `GetOptOutScreenDetailsRPC(emailId='${this.emailId}')`;
  };
  

  export class InvalidResponseError extends Error {
    constructor(message?: string) {
      super(message);
      Object.setPrototypeOf(this, new.target.prototype);
      this.name = "InvalidResponseError";
    }
  }

  export interface ResponseDTO {
    projectName: BoundedNameDTO;
    email: KeycloakEmailDTO;
  }
  
  export class Response implements LeoRPCResponse {
    readonly isGetOptOutScreenDetailsResponse: boolean = true;
  
    readonly projectName: BoundedName;
    readonly email: KeycloakEmail;
  
  
    constructor(
    projectName: BoundedName, 
    email: KeycloakEmail
    ) {
      this.projectName = projectName;
      this.email = email;
    }
  
    static fromDTO(dto: ResponseDTO): Response {
      const projectName = BoundedName.fromDTO(getObject(dto, "projectName", InvalidResponseProjectNameError));
      const email = KeycloakEmail.fromDTO(getObject(dto, "email", InvalidResponseEmailError));
      return new Response(
        projectName,
        email
      );
    }
  
    toDTO(): ResponseDTO {
      const dto: ResponseDTO = {
          projectName: this.projectName.toDTO(),
          email: this.email.toDTO()
      };
      return dto;
    }
    }
  
  Response.prototype.toString = function toString(): string {
    return `GetOptOutScreenDetails(projectName='${this.projectName}',email='${this.email}')`;
  };
  

  export enum RPCError {
    InvalidEmailId = "INVALID_EMAIL_ID"
  }

  export namespace Errors {
    
    export interface InvalidEmailIdDTO {
      code: string;
    }
    
    export class InvalidEmailId extends LeoRPCError<RPCError> {
      readonly isInvalidEmailId: boolean = true;
    
    
      constructor(
      ) {
        const code = RPCError.InvalidEmailId;
        super(code);
      }
    
    
      toDTO(): InvalidEmailIdDTO {
        const dto: InvalidEmailIdDTO = {
          code: this.code,
        };
        return dto;
      }
    
      }
    
    InvalidEmailId.prototype.toString = function toString(): string {
      return `GetOptOutScreenDetailsRPC.INVALID_EMAIL_ID()`;
    };
    

    export type Errors = InvalidEmailId;
    export type ErrorsDTO = InvalidEmailIdDTO;

    export const fromDTO = (dto: ErrorsDTO): Errors => {
      switch (dto.code) {
        case RPCError.InvalidEmailId:
          return new InvalidEmailId();
        default:
          throw new InvalidResponseError(`Unexpected error code: ${dto.code}`);
      }
    };
  }
}

export class InvalidRequestEmailIdError extends GetOptOutScreenDetailsRPC.InvalidRequestError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidRequestEmailIdError";
  }
}

export class InvalidResponseProjectNameError extends GetOptOutScreenDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseProjectNameError";
  }
}

export class InvalidResponseEmailError extends GetOptOutScreenDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseEmailError";
  }
}

export class InvalidResponseInvalidEmailIdError extends GetOptOutScreenDetailsRPC.InvalidResponseError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidResponseInvalidEmailIdError";
  }
}

